unable to read source [project]/frontend/node_modules/src/html5-qrcode.ts